import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';

export const shopMilesRulesOnInitEval = (
  bookWidgetFields: BookWidgetFields
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (updatedBookWidgetFields.shopMilesField.checked) {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      refundableFareField: {
        ...updatedBookWidgetFields.refundableFareField,
        disable: true,
        checked: false
      },
      meetingEventCodeField: {
        ...updatedBookWidgetFields.meetingEventCodeField,
        hide: true,
        meetingEventCodeValue: ''
      }
    };
  }

  return updatedBookWidgetFields;
};
